import { ArrowUpRight, Plus2 } from '@/shared/assets';
import { ICurrencyAccount } from '@/shared/lib';
import { Button, Mobile } from '@/shared/ui';

import { AddMoneyFlowModal } from './cards/add-flow';
//import { useAddMoney } from '../model/useAddMoney';
import { SendMoneyFlowModal } from './cards/send-money-flow';
// TODO: restore Exchange
// import { useExchangeNavigation } from '@/shared/lib';
// import { RightLeftArrow } from '@/shared/assets';

export const MobileAccountActions: React.FC<{ account: ICurrencyAccount }> = ({
  account,
}) => {
  //const resetAddData = useAddMoney((state) => state.resetAddData);

  // TODO: restore Exchange
  // const { handleGoToExchange } = useExchangeNavigation();

  return (
    <Mobile>
      <div className="absolute -bottom-[-18px] grid w-full grid-cols-2 gap-x-1">
        <AddMoneyFlowModal account={account}>
          <Button
            variant="surface-01"
            className="rounded-full px-2.5 py-5"
          //onClick={resetAddData}
          >
            <Plus2 className="min-h-6 min-w-6" />
          </Button>
        </AddMoneyFlowModal>
        <SendMoneyFlowModal>
          <Button variant="surface-01" className="rounded-full px-2.5 py-5">
            <ArrowUpRight className="min-h-6 min-w-6" />
          </Button>
        </SendMoneyFlowModal>
        {/* TODO: restore Exchange */}
        {/* <Button
          variant="surface-01"
          className="rounded-full px-2.5 py-5"
          onClick={handleGoToExchange}
        >
          <RightLeftArrow className="min-h-6 min-w-6" />
        </Button> */}
      </div>
    </Mobile>
  );
};
